import { createAction, createPayloadAction } from '../../../core/helpers'

import {
  ADD_LOCATION_TYPE_OR_LOCATION_TYPE_CATEGORY_NODE,
  EXPAND_LOCATION_TYPE_AND_LOCATION_TYPE_CATEGORY_MAIN_TREE_KEYS,
  EXPAND_LOCATION_TYPE_AND_LOCATION_TYPE_CATEGORY_SUPPORTING_TREE_KEYS,
  FETCH_LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES,
  MOVE_LOCATION_TYPES,
  RENAME_LOCATION_TYPE_OR_LOCATION_TYPE_CATEGORY_NODE,
  REPLACE_LOCATION_TYPE,
  RESET_LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES_TREE,
  SET_DATA_FOR_RENAMING_LOCATION_TYPE_OR_LOCATION_TYPE_CATEGORY_NODE,
} from '../action-types'

export const cleanupFetchLocationTypesAndLocationTypeCategories = createAction(
  FETCH_LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES.CLEANUP,
)

export const addLocationTypeOrLocationTypeCategoryNode = createPayloadAction(
  ADD_LOCATION_TYPE_OR_LOCATION_TYPE_CATEGORY_NODE,
)

export const renameLocationTypeOrLocationTypeCategoryNode = createPayloadAction(
  RENAME_LOCATION_TYPE_OR_LOCATION_TYPE_CATEGORY_NODE,
)

export const resetLocationTypesAndLocationTypeCategoriesTree = createAction(
  RESET_LOCATION_TYPES_AND_LOCATION_TYPE_CATEGORIES_TREE,
)

export const setDataForRenamingLocationTypeOrLocationTypeCategory =
  createPayloadAction(
    SET_DATA_FOR_RENAMING_LOCATION_TYPE_OR_LOCATION_TYPE_CATEGORY_NODE,
  )

export const moveLocationTypes = createPayloadAction(MOVE_LOCATION_TYPES)
export const replaceLocationType = createPayloadAction(REPLACE_LOCATION_TYPE)

export const expandLocationTypeAndLocationTypeCategoryMainTreeKeys =
  createPayloadAction(
    EXPAND_LOCATION_TYPE_AND_LOCATION_TYPE_CATEGORY_MAIN_TREE_KEYS,
  )

export const expandLocationTypeAndLocationTypeCategorySupportingTreeKeys =
  createPayloadAction(
    EXPAND_LOCATION_TYPE_AND_LOCATION_TYPE_CATEGORY_SUPPORTING_TREE_KEYS,
  )
